import styled, { keyframes, css } from 'styled-components';
import { darken } from 'polished';

const COR_MARCA = '#ff6d3c';
const COR_TEXTO = '#2c405a';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const girar = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const pulsar = keyframes`
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.94);
    opacity: 0.7;
  }
`;

export const SsoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 40px 24px;
  text-align: center;
  background: radial-gradient(
    circle at 50% 30%,
    #ffffff 0%,
    #f4f7fb 55%,
    #eef2f7 100%
  );
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 440px;
  padding: 44px 36px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(44, 64, 90, 0.12),
    0 0 0 1px rgba(44, 64, 90, 0.04);
  animation: ${fadeInUp} 0.45s ease both;
`;

export const Logo = styled.img`
  width: 132px;
  height: auto;
  ${(props) =>
    props.pulse &&
    css`
      animation: ${pulsar} 1.8s ease-in-out infinite;
    `}
`;

export const Spinner = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 4px solid rgba(255, 109, 60, 0.18);
  border-top-color: ${COR_MARCA};
  animation: ${girar} 0.8s linear infinite;
`;

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: rgba(255, 109, 60, 0.1);
  color: ${COR_MARCA};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${COR_TEXTO};
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14.5px;
  line-height: 1.5;
  color: rgba(44, 64, 90, 0.62);
  max-width: 340px;
`;

export const ActionButton = styled.button`
  margin-top: 6px;
  min-width: 200px;
  padding: 13px 32px;
  border: 0;
  border-radius: 12px;
  background: ${COR_MARCA};
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 24px rgba(255, 109, 60, 0.28);

  &:hover {
    background: ${darken(0.08, COR_MARCA)};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
